export const TOAST_MESSAGES = {
  success: {
    login: "Login successful!",
  },
  error: {
    loginInvalid: "Invalid email or password",
    loginFailed: "An error occurred during login",
  },
} as const;

export const VALIDATION_MESSAGES = {
  email: {
    required: "Email is required",
    invalid: "Enter a valid email address",
  },
  password: {
    required: "Password is required",
  },
} as const;
